import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/** Home partners marquee — pulls live sponsors from DB (same as Destekçilerimiz page). */
export default function PartnersMarquee() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.publicContent('sponsors').then(list => {
      if (Array.isArray(list) && list.length > 0) {
        setItems(list.map(it => ({ id: it.id, ...(it.data || {}) })));
      }
    }).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const doubled = [...items, ...items];

  return (
    <div className="bg-cream border-y border-ink-100 overflow-hidden py-8" data-testid="home-partners-marquee">
      <div className="relative">
        <div className="flex items-center gap-12 md:gap-16 animate-marquee whitespace-nowrap" style={{ width: 'max-content' }}>
          {doubled.map((s, i) => (
            <div key={`${s.id || 'x'}-${i}`} className="flex items-center shrink-0 h-16 opacity-60 hover:opacity-100 transition-opacity">
              {s.logo ? (
                <img src={s.logo} alt={s.name} className="max-h-14 w-auto object-contain" />
              ) : (
                <span className="font-display text-ink-400 text-xl md:text-2xl tracking-wide">{s.name}</span>
              )}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-cream to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-cream to-transparent" />
      </div>
    </div>
  );
}
